import { render, staticRenderFns } from "./OrgHomeIntakeReferredOut.vue?vue&type=template&id=68286773&scoped=true&"
import script from "./OrgHomeIntakeReferredOut.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntakeReferredOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68286773",
  null
  
)

export default component.exports